module.exports = __webpack_public_path__ + "images/emoji/baggage_claim.1386fd1282a65ff53fbb.png";